import { WebRequest } from 'framework-ui-components';

export const dichiarazioni = (studio) => WebRequest.get('Successioni/Tutte', { studio });

export const elimina = (idDichiarazione) => WebRequest.post('Successioni/Elimina', {}, { idDichiarazione });

export const completa = (idDichiarazione) => WebRequest.post('Successioni/Completa', {}, { idDichiarazione });

export const riapri = (idDichiarazione) => WebRequest.post('Successioni/Riapri', {}, { idDichiarazione });

export const daInviare = (idDichiarazione) => WebRequest.post('Successioni/DaInviare', {}, { idDichiarazione });

export const statiSuccessioni = (studio, termineRicerca) => WebRequest.get('Successioni/StatiSuccessioni', { studio, termineRicerca });

export const creaSuccessione = (studio, codiceFiscale, nome, cognome, tipo,
  dataDecesso, tipoDevoluzione, comuneUltimaResidenza,
  codiceComuneUltimaResidenza, provinciaUltimaResidenza, flagMortePresunta,
  quadroEb, quadroEc, quadroEd, quadroEg, quadroEh, quadroEi, quadroEl,
  quadroEm, quadroEn, quadroEo, quadroEp, quadroEq, quadroEr, quadroEs) => WebRequest.post('Successioni/Crea', {
  Studio: studio,
  CodiceFiscale: codiceFiscale,
  Nome: nome,
  Cognome: cognome,
  TipoDichiarazione: tipo,
  DataDecesso: dataDecesso,
  TipoDevoluzione: tipoDevoluzione,
  ComuneUltimaResidenza: comuneUltimaResidenza,
  CodiceComuneUltimaResidenza: codiceComuneUltimaResidenza,
  ProvinciaUltimaResidenza: provinciaUltimaResidenza,
  FlagMortePresunta: flagMortePresunta,
  QuadroEb: quadroEb,
  QuadroEc: quadroEc,
  QuadroEd: quadroEd,
  QuadroEg: quadroEg,
  QuadroEh: quadroEh,
  QuadroEi: quadroEi,
  QuadroEl: quadroEl,
  QuadroEm: quadroEm,
  QuadroEn: quadroEn,
  QuadroEo: quadroEo,
  QuadroEp: quadroEp,
  QuadroEq: quadroEq,
  QuadroEr: quadroEr,
  QuadroEs: quadroEs,
});

export const creaSostitutivaDaEsistente = (id, tipo, studio) => WebRequest.post('Successioni/CreaSostitutivaDaEsistente', {}, { idDichiarazione: id, tipo, studio });

export const trasmettiManualmente = (id, data, protocollo, volume, numero, anno, datareg) => WebRequest.post('Successioni/TrasmettiManualmente', {}, {
  idDichiarazione: id,
  dataRicevutaDiTrasmissione: data,
  protocollo,
  volumePrimaDichiarazione: volume,
  numeroPrimaDichiarazione: numero,
  annoPrimaDichiarazione: anno,
  dataPrimaDichiarazione: datareg,
});

export const arretraTrasmessaManualmente = (id) => WebRequest.post('Successioni/ArretraDichiarazioneTrasmessaManualmente', {}, { idDichiarazione: id });
